import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface ClubReadyLocationConfigurationValid {
    type: 'VALID';
    clubId: string;
}

export interface ClubReadyLocationConfigurationMissing {
    type: 'MISSING_CLUB_ID';
}

export type ClubReadyLocationConfigurationUnion =
    | ClubReadyLocationConfigurationMissing
    | ClubReadyLocationConfigurationValid;

export class ClubReadyLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    ClubReadyLocationConfigurationUnion,
    'CLUB_READY_LOCATION'
>('CLUB_READY_LOCATION') {}
